import { getIn } from 'formik'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { CsatDesktop, CsatMobile } from './style'

const colorfulCSAT = {
  1: '#B72224',
  2: '#E95223',
  3: '#EBDB0A',
  4: '#81BD54',
  5: '#26BA54'
}

const grayscaleCSAT = {
  1: '#181818',
  2: '#383838',
  3: '#787878',
  4: '#989898',
  5: '#B8B8B8'
}

const getItemStyle = (
  item,
  value,
  colorTheme = 'colorful',
  isVertical = false
) => {
  const colorsCSAT = colorTheme === 'grayscale' ? grayscaleCSAT : colorfulCSAT

  return {
    backgroundColor: colorsCSAT[item],
    color: '#fff',
    width: '100%',
    height: isVertical ? '50px' : '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '18px',
    border: value === item.toString() ? '1px solid #333' : 'none',
    userSelect: 'none'
  }
}

const ColorScaleInput = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  colorTheme = 'colorful'
}) => {
  const value =
    isNaN(field.value) || field.value === '' ? '' : field.value.toString()

  const handleClick = (item) => {
    setFieldValue(field.name, item.toString())
  }

  const hasError = getIn(touched, field.name) && getIn(errors, field.name)

  return (
    <Box
      mb={3}
      component="fieldset"
      borderColor="transparent"
      className={`form-field checkbox-field ${
        hasError ? 'checkbox-error' : ''
      }`}
    >
      {label && <Typography component="legend">{label}</Typography>}

      <CsatDesktop>
        {[1, 2, 3, 4, 5].map((item) => (
          <div
            key={item}
            onClick={() => handleClick(item)}
            style={getItemStyle(item, value, colorTheme)}
          >
            {item}
          </div>
        ))}
      </CsatDesktop>

      <CsatMobile>
        {[1, 2, 3, 4, 5].reverse().map((item) => (
          <div
            key={item}
            onClick={() => handleClick(item)}
            style={getItemStyle(item, value, colorTheme, true)}
          >
            {item}
          </div>
        ))}
      </CsatMobile>
    </Box>
  )
}

export default ColorScaleInput
